// src/lib/auth.ts
import CredentialsProvider from 'next-auth/providers/credentials';
import { AuthOptions } from 'next-auth';

export const authOptions: AuthOptions = {
  providers: [
    CredentialsProvider({
      name: 'Backend Verified User Data',
      credentials: {
        uid: { label: 'Firebase UID', type: 'text', required: true },
        idToken: { label: 'ID Token', type: 'text', required: true },
      },
      async authorize(credentials) {
        if (!credentials?.uid || !credentials.idToken) return null;
        return {
          id: credentials.uid,
          firebase_uid: credentials.uid,
          idToken: credentials.idToken,
        };
      },
    }),
  ],
  session: { strategy: 'jwt' },
  callbacks: {
    async jwt({ token, user }) {
      if (user) {
        token.id = user.id;
        token.firebase_uid = user.firebase_uid;
        token.idToken = user.idToken;
      }
      return token;
    },
    async session({ session, token }) {
      session.user.id = token.id as string;
      session.user.firebase_uid = token.firebase_uid as string;
      session.user.idToken = token.idToken as string;
      return session;
    },
  },
  pages: { signIn: '/login' },
  secret: process.env.NEXTAUTH_SECRET!,
};
